export const UserReviewMessage = {
    USER_APPROVED: 'User has been successfully approved.',
    USER_REJECTED: 'User has been successfully rejected.',
    USER_CHANGES_SAVED: 'User changes have been successfully saved.',
} as const;
